import type RouteInfo from '@ember/routing/route-info'

export enum SubscriptionType {
  Reading = 'reading',
  Maths = 'maths',
  Writing = 'writing',
}

/**
 * @deprecated - replace with SubscriptionType.Reading
 */
export const SUBSCRIPTION_TYPE_READING = SubscriptionType.Reading
/**
 * @deprecated - replace with SubscriptionType.Maths
 */
export const SUBSCRIPTION_TYPE_MATHS = SubscriptionType.Maths

export function isSubscriptionType(maybeSubscriptionType: unknown): maybeSubscriptionType is SubscriptionType {
  const valid = Object.values<string>(SubscriptionType)
  return typeof maybeSubscriptionType === 'string' && valid.includes(maybeSubscriptionType)
}

export function extractSubscriptionTypeFromRouteInfo(routeInfo?: Nullable<RouteInfo>): SubscriptionType | undefined {
  // find() is always defined on RouteInfo, but allowed to be optional so that integration tests don't need to stub it
  const paramSubscriptionType = routeInfo?.find?.(({ name }) => name === 'subscription-type')?.params?.subscription_type
  if (isSubscriptionType(paramSubscriptionType)) return paramSubscriptionType
  return undefined
}
